/* QUOR offer ladder: self-starting custom element so it works on the PDP and inside the quick-buy drawer. */
(function () {
  "use strict";
  if (window.customElements.get("quor-offer-ladder")) return;

  var money = function (n) { return "$" + (Math.round(n * 100) % 100 === 0 ? n.toFixed(0) : n.toFixed(2)); };

  class QuorOfferLadder extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      var cfgEl = this.querySelector("script[data-qol-config]");
      if (!cfgEl) return;
      this._ready = true;
      this.cfg = JSON.parse(cfgEl.textContent);
      this.state = { tier: "3mo", mode: "sub", flavor: "Sour Apple", variant: this.cfg.defaultVariant };
      this.bind();
      this.render();
    }

    $(name) { return this.querySelector('[data-qol="' + name + '"]'); }

    tier() {
      var tiers = this.cfg.tiers;
      for (var i = 0; i < tiers.length; i++) if (tiers[i].id === this.state.tier) return tiers[i];
      return tiers[0];
    }
    mode() { return this.tier().canSub ? this.state.mode : "once"; }
    unit(t, m) { return (m === "sub" && t.canSub) ? t.subPrice : t.once; }

    render() { this.renderPacks(); this.renderBuy(); }

    renderPacks() {
      var self = this, box = this.$("packs");
      box.innerHTML = "";
      this.cfg.tiers.forEach(function (t) {
        if (t.split) {
          var s = document.createElement("div");
          s.className = "ladder-split"; s.textContent = "WANT TO TRY ALL THE FLAVORS?";
          box.appendChild(s);
        }
        var p = self.unit(t, t.canSub ? self.state.mode : "once");
        var b = document.createElement("button");
        b.type = "button";
        b.className = "pack" + (t.id === self.state.tier ? " on" : "");
        b.innerHTML = '<span class="radio"></span>' +
          '<span class="pk-main"><span class="pk-name">' + (t.variety ? "VARIETY TRIO" : t.months) +
            (t.tag ? '<span class="pk-tag">' + t.tag + '</span>' : '') + '</span>' +
          '<span class="pk-sub">' + t.ships + '</span>' +
          (t.variety ? '<span class="pk-dots"><span class="fp-a">Sour Apple</span><span class="fp-b">Blue Razz</span><span class="fp-c">Wilde Watermelon</span></span>' : '') +
          '</span>' +
          '<span class="pk-right">' + (p < t.list ? '<span class="pk-was">' + money(t.list) + '</span>' : '') +
          '<span class="pk-price">' + money(p) + '</span>' +
          '<span class="pk-day">' + money(p / t.days) + ' / day</span></span>';
        b.addEventListener("click", function () { self.state.tier = t.id; self.render(); });
        box.appendChild(b);
      });
    }

    renderBuy() {
      var self = this, t = this.tier(), m = this.mode(), now = this.unit(t, m);

      Array.prototype.forEach.call(this.$("buytype").children, function (btn) {
        var isSub = btn.getAttribute("data-type") === "sub";
        btn.classList.toggle("on", (m === "sub") === isSub);
        btn.disabled = isSub && !t.canSub;
      });

      this.$("priceNow").textContent = money(now);
      var save = Math.round((t.list - now) * 100) / 100;
      this.$("priceWas").style.display = save > 0 ? "" : "none";
      this.$("priceWas").textContent = money(t.list);
      this.$("priceSave").style.display = save > 0 ? "" : "none";
      this.$("priceSave").textContent = "SAVE " + money(save);
      this.$("subPrice").textContent = t.canSub ? money(t.subPrice) : "—";
      this.$("oncePrice").textContent = money(t.once);
      var pct = t.canSub ? Math.round((t.once - t.subPrice) / t.once * 100) : 0;
      this.$("subSaveBadge").style.display = pct > 0 ? "" : "none";
      this.$("subSaveBadge").textContent = "SAVE " + pct + "%";
      this.$("subSaveLine").textContent = pct + "% off the one-time price";

      var pd = now / t.days;
      var pctLessCoffee = Math.round((this.cfg.coffee - pd) / this.cfg.coffee * 100);
      this.$("perDay").textContent = "About " + money(pd) + " per day. That's " + pctLessCoffee + "% less than a $3 coffee.";
      this.$("priceMeta").textContent = (m === "sub" ? "Ships every " + t.days + " days · Cancel any time" : "One-time order");

      // "Full one-time price" only when once == list; "No free shipping" only under the free-shipping minimum.
      this.$("onceFullPriceLine").style.display = (t.once >= t.list) ? "" : "none";
      this.$("onceShipLine").style.display = (t.once < this.cfg.freeShipMin) ? "" : "none";
      this.$("consent").style.display = m === "sub" ? "" : "none";

      var variety = !!t.variety;
      this.$("sizeVal").textContent = t.months;
      this.$("flavorVal").textContent = variety ? "All 3 Included" : this.state.flavor;
      this.$("planVal").textContent = m === "sub" ? "Subscribe" : "One time";
      this.$("flavors").classList.toggle("bundle", variety);
      Array.prototype.forEach.call(this.$("flavors").children, function (btn) {
        btn.classList.toggle("locked", variety);
        btn.classList.toggle("on", !variety && btn.getAttribute("data-flavor") === self.state.flavor);
      });

      if (variety) {
        this.$("formVariant").value = t.trioVariant;
        this.$("formQty").value = 1;
      } else {
        var sel = this.$("flavors").querySelector('[data-flavor="' + this.state.flavor + '"]');
        this.$("formVariant").value = sel ? sel.getAttribute("data-variant") : this.state.variant;
        this.$("formQty").value = t.qty;
      }
      this.$("formPlan").value = (m === "sub" && t.planId) ? t.planId : "";
    }

    bind() {
      var self = this;
      Array.prototype.forEach.call(this.$("buytype").children, function (btn) {
        btn.addEventListener("click", function () {
          if (btn.disabled) return;
          self.state.mode = btn.getAttribute("data-type") === "sub" ? "sub" : "once";
          self.render();
        });
      });
      Array.prototype.forEach.call(this.$("flavors").children, function (btn) {
        btn.addEventListener("click", function () {
          if (self.tier().variety) return;
          self.state.flavor = btn.getAttribute("data-flavor");
          self.state.variant = btn.getAttribute("data-variant");
          self.renderBuy();
        });
      });

      // AJAX add so Shopify errors show inline.
      this.querySelector("form.qol-form").addEventListener("submit", function (e) {
        e.preventDefault();
        var btn = self.$("atc"), original = btn.textContent;
        btn.disabled = true; btn.textContent = "ADDING…";
        var payload = { id: parseInt(self.$("formVariant").value, 10), quantity: parseInt(self.$("formQty").value, 10) };
        var plan = self.$("formPlan").value;
        if (plan) payload.selling_plan = plan;

        fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", "Accept": "application/json" },
          body: JSON.stringify(payload)
        })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, status: r.status, body: j }; }); })
        .then(function (res) {
          if (res.ok) {
            // Page redirects to /cart next, so no cart:change event.
            window.location.href = "/cart";
          } else {
            console.error("[offer-ladder] Cart error", res.status, res.body);
            alert(res.body.description || res.body.message || "Could not add to cart. Please try again.");
            btn.disabled = false; btn.textContent = original;
          }
        })
        .catch(function (err) {
          console.error("[offer-ladder] Network error", err);
          alert("Network error. Please try again.");
          btn.disabled = false; btn.textContent = original;
        });
      });

      var scrim = this.$("policyScrim");
      this.$("policyLink").addEventListener("click", function () { scrim.classList.add("show"); });
      this.$("closePolicy").addEventListener("click", function () { scrim.classList.remove("show"); });
      scrim.addEventListener("click", function (e) { if (e.target === scrim) scrim.classList.remove("show"); });
      document.addEventListener("keydown", function (e) { if (e.key === "Escape") scrim.classList.remove("show"); });
    }
  }

  window.customElements.define("quor-offer-ladder", QuorOfferLadder);
})();
